<div class="pos-r">
  <app-loader *ngIf="dataLoading"></app-loader>
  <app-loader *ngIf="saveOrCreateLoading"></app-loader>
  <form *ngIf="!dataLoading" [formGroup]="plotCreateEditForm">
    <steps (onSaveStepsCallback)="onSaveStepsCallback()" (onResetStepsCallback)="onResetStepsCallback()">
      <step [title]="'Шаг 1'" [description]="'Головной офис участка'">
        <div class="grid mb-16">
          <div class="grid__box grid__box--size-2">
            <div class="title">Роль участка</div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-11 dropdown-menu--small">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Роль</span>
                  </div>
                  <div class="grid__box grid__box--size-4 dropdown-menu--small">
                    <input type="hidden" formControlName="sector_role" />
                    <app-select
                      [items]="roleList"
                      (callback)="onChangeRole($event)"
                      [textKey]="'name'"
                      [defaultText]="'Выберите роль участка'"
                      [initBy]="roleSelected"
                      [name]="'sector_role'"
                    ></app-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">Головной офис участка</div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-11 dropdown-menu--small">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Компания</span>
                  </div>
                  <div class="grid__box grid__box--size-4 dropdown-menu--small">
                    <input type="hidden" formControlName="partnership_id" />
                    <app-combobox
                      [items]="companiesList"
                      (callback)="onChangeCompany($event)"
                      [textKey]="'new_name'"
                      [defaultText]="'Выберите компанию'"
                      [initBy]="companySelected"
                      [name]="'company'"
                    ></app-combobox>
                  </div>
                  <div
                    class="grid__box grid__box--size-min"
                    *ngIf="isEditMode && currentSelectedPlot.is_visible && companySelected && companySelected.campaign_id !== currentSelectedPlot.partnership_id"
                  >
                    <span class="text-italic color-red-dark">
                      Участок будет удален у всех сотрудников,<br />
                      привязанных к этому участку
                    </span>
                  </div>
                </div>
                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Регион</span>
                  </div>
                  <div class="grid__box grid__box--size-4">
                    <app-select
                      [items]="regionsList"
                      (callback)="onChangeRegion($event)"
                      [textKey]="''"
                      [defaultText]="'Выберите регион'"
                      [initBy]="regionSelected"
                      [isDisabled]="isEditMode"
                      [name]="'region'"
                    ></app-select>
                  </div>
                </div>
                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Филиал</span>
                  </div>
                  <div class="grid__box grid__box--size-4 dropdown-menu--small">
                    <input type="hidden" formControlName="market_branch" />
                    <app-combobox
                      [items]="branchesList"
                      (callback)="onChangeBranch($event)"
                      [textKey]="'mb_name'"
                      [defaultText]="'Выберите филиал'"
                      [initBy]="branchSelected"
                      [isDisabled]="isEditMode"
                      [name]="'marketBranch'"
                    ></app-combobox>
                  </div>
                </div>
                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Город</span>
                  </div>
                  <div class="grid__box grid__box--size-4 dropdown-menu--small">
                    <app-typeahead>
                      <input
                        type="text"
                        class="input-text"
                        formControlName="city_name"
                        id="cityName"
                        autocomplete="password"
                        [ngbTypeahead]="searchCity"
                        #instance="ngbTypeahead"
                        (focus)="focusCity$.next($event.target.value)"
                        (click)="clickCity$.next($event.target.value)"
                        fieldTrim
                      />
                    </app-typeahead>
                  </div>
                </div>
                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Тип улицы</span>
                  </div>
                  <div class="grid__box grid__box--size-4 dropdown-menu--small">
                    <input type="hidden" formControlName="street_type" />
                    <app-combobox
                      [items]="streetTypesList"
                      (callback)="onChangeStreetType($event)"
                      [textKey]="'st_type'"
                      [defaultText]="'Выберите тип'"
                      [initBy]="streetTypeSelected"
                      [name]="'streetType'"
                    ></app-combobox>
                  </div>
                </div>
                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Улица</span>
                  </div>
                  <div class="grid__box grid__box--size-4">
                    <app-field>
                      <input type="text" class="input-text" id="streetName" formControlName="street_name" fieldTrim />
                    </app-field>
                  </div>
                </div>
                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Дом</span>
                  </div>
                  <div class="grid__box grid__box--size-4">
                    <div class="grid grid--gap-0">
                      <div class="grid__box grid__box--size-3">
                        <div class="grid">
                          <div class="grid__box grid__box--size-8">
                            <app-field>
                              <input class="input-text" type="text" id="houseNumber" formControlName="house_number" fieldTrim />
                            </app-field>
                          </div>
                        </div>
                      </div>
                      <div class="grid__box">
                        <div class="grid grid--gap-8 grid--va-middle">
                          <div class="grid__box ta-right">
                            <span class="title title--s">Строение</span>
                          </div>
                          <div class="grid__box grid__box--size-5">
                            <app-field>
                              <input class="input-text" type="text" id="houseBuilding" formControlName="house_building" fieldTrim />
                            </app-field>
                          </div>
                        </div>
                      </div>
                      <div class="grid__box">
                        <div class="grid grid--gap-8 grid--va-middle">
                          <div class="grid__box ta-right">
                            <span class="title title--s">Офис</span>
                          </div>
                          <div class="grid__box grid__box--size-5">
                            <app-field>
                              <input class="input-text" type="text" id="officeNumber" formControlName="office_number" fieldTrim />
                            </app-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-2">
                    <div class="title title--vertical title--s title--required">Координаты GPS</div>
                  </div>
                  <div class="grid__box grid__box--size-2">
                    <app-field>
                      <input class="input-text" id="latitude" type="text" placeholder="Широта" formControlName="latitude" fieldRegexp [regexp]="'[^0-9.]'" />
                    </app-field>
                  </div>
                  <div class="grid__box grid__box--size-2">
                    <app-field>
                      <input class="input-text" id="longitude" type="text" placeholder="Долгота" formControlName="longitude" fieldRegexp [regexp]="'[^0-9.]'" />
                    </app-field>
                  </div>
                </div>
                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s">Ответственное лицо</span>
                  </div>
                  <div class="grid__box grid__box--size-4 dropdown-menu--small">
                    <input type="hidden" formControlName="sector_head" />
                    <app-combobox
                      [items]="responsibleList"
                      (callback)="onChangeResponsible($event)"
                      [textKey]="'full_name'"
                      [defaultText]="'Выберите сотрудника'"
                      [initBy]="responsibleSelected"
                      [name]="'sectorHead'"
                      [isDisabled]="!companySelected || !branchSelected"
                    ></app-combobox>
                  </div>
                </div>
                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-2">
                    <div class="title title--s">Контактный номер</div>
                  </div>
                  <div class="grid__box grid__box--size-4">
                    <div *ngIf="responsibleSelected">
                      {{ responsibleSelected.phone | phoneFormat }}
                    </div>
                    <div *ngIf="!responsibleSelected" class="mdash"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </step>
      <step [title]="'Шаг 2'" [description]="'Участок<br>Дополнительные настройки<br>Сведения об изменении записи'">
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">Участок</div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-11">
                <div class="grid">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title-vertical title--s title--required">Район</span>
                  </div>
                  <div class="grid__box grid__box--size-10" formArrayName="districts">
                    <ng-container *ngIf="districtList && plotCreateEditForm.value.districts.length < districtList.length">
                      <div class="mb-4" *ngFor="let group of districtGroupList | keyvalue">
                        <span class="font-weight-bold color-blue-dark mr-2">{{ group.value.ct_name }} :</span>
                        <span *ngFor="let district of group.value.districts; let last = last"> {{ district.district_name }}<span *ngIf="!last">,</span> </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="districtList && plotCreateEditForm.value.districts.length === districtList.length">
                      <div class="mb-4">Все районы</div>
                    </ng-container>
                    <div>
                      <app-search-popover
                        [items]="districtList"
                        [textKey]="'new_district_name'"
                        [checkedKey]="'is_checked'"
                        [emptyItemsMessage]="'Для выбора участка заполните обязательные поля на шаге 1 и филиал в этом блоке'"
                        (onClose)="onCloseSearchPopover()"
                      ></app-search-popover>
                    </div>
                  </div>
                </div>
                <div class="grid mt-16" *ngIf="showDistrictCoefficients">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title--vertical title--s">Коэффициенты районов</span>
                  </div>
                  <div class="grid__box grid__box--size-10">
                    <app-district-coefficients [districts]="plotCreateEditForm.get('districts').value"></app-district-coefficients>
                  </div>
                </div>
                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title--vertical title--required title--s">Идентификатор участка</span>
                  </div>
                  <div class="grid__box grid__box--size-2">
                    <input class="input-text" type="hidden" id="sectorId" formControlName="sector_id" />
                    <span *ngIf="isEditMode">
                      {{ currentSelectedPlot.sector_number_str }}
                    </span>
                    <span *ngIf="!isEditMode && branchSelected">
                      {{ branchSelected.mb_region_id }}
                      .{{ sectorNumberData && sectorNumberData.next_sector_id }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-24 mb-24">
          <div class="grid__box--size-4">
            <div class="grid">
              <div class="grid__box grid__box--size-5">
                <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">
              Дополнительные<br />
              настройки
            </div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-11">
                <div class="grid">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title--vertical title--s">Отображение в системе</span>
                  </div>
                  <div class="grid__box grid__box--size-min">
                    <app-checkbox-slider>
                      <input type="checkbox" id="checkboxSlider" formControlName="is_visible" />
                    </app-checkbox-slider>
                  </div>
                  <div class="grid__box grid__box--size-min" *ngIf="isEditMode && !plotCreateEditForm.value.is_visible && currentSelectedPlot.is_visible">
                    <span class="text-italic color-red-dark">
                      Участок будет удален у всех сотрудников,<br />
                      привязанных к этому участку
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="isEditMode && currentSelectedPlot?.sector_id && autoDistributionAvailable">
          <div class="grid mt-24 mb-24">
            <div class="grid__box--size-4">
              <div class="grid">
                <div class="grid__box grid__box--size-5">
                  <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="grid__box grid__box--size-2">
              <div class="title">
                Автоматическое<br />
                распределение
              </div>
            </div>
            <div class="grid__box grid__box--size-10">
              <!-- В адресе страницы s_id (id записи/версии), а настройки привязаны к sector_id участка -->
              <app-sector-distribution-options [sectorId]="currentSelectedPlot.sector_id"></app-sector-distribution-options>
            </div>
          </div>
        </ng-container>
        <div class="grid grid--va-middle" *ngIf="isEditMode && isVisibleMigrateEmployersBlock">
          <div class="grid__box grid__box--size-2"></div>
          <div class="grid__box grid__box--size-8">
            <div class="mt-32">Замените участок 15.12 в профилях сотрудников на любой другой.</div>
            <div class="loader-left" *ngIf="migrateLoading">
              <app-loader [position]="'reset'"></app-loader>
            </div>
            <div *ngIf="!migrateLoading">
              <div class="grid grid--va-middle mt-16">
                <div class="grid__box grid__box--size-min">
                  <span class="title title--s">Массовая замена</span>
                </div>
                <div class="grid__box grid__box--size-min">
                  <app-combobox
                    [items]="migrateSectorsList"
                    (callback)="onChangeSelectedSectorForMigrateEmployers($event)"
                    [textKey]="'sector_number_str'"
                    [initBy]="sectorSelectedForMigrateUsers"
                    [name]="'changeSectorGroup'"
                    [defaultText]="'Выберите участок'"
                  ></app-combobox>
                </div>
                <div class="grid__box grid__box--size-min">
                  <button
                    class="button"
                    id="employeeChangeSectorGroup"
                    (click)="onChangeSectorCheckedEmployers()"
                    [disabled]="!isSomeMigrateEmployeeChecked || !sectorSelectedForMigrateUsers"
                  >
                    Выбрать у отмеченных
                  </button>
                </div>
              </div>
              <div class="mt-16">
                <table class="tbl tbl--hovered">
                  <thead>
                    <colgroup>
                      <col width="4%" />
                      <col />
                      <col width="10%" />
                      <col width="10%" />
                      <col width="15%" />
                    </colgroup>
                    <tr>
                      <th>
                        <app-checkbox>
                          <input type="checkbox" id="checkedAllEmployers" name="checkedAllEmployers" [checked]="isAllEmployeeChecked" (change)="onCheckAllEmployers($event)" />
                        </app-checkbox>
                      </th>
                      <th>ФИО</th>
                      <th>Тип</th>
                      <th>Основная роль</th>
                      <th>Новый участок</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let employee of employersSectorsList"
                      [ngClass]="{
                        'bg-green-light': employee.sector
                      }"
                    >
                      <td>
                        <app-checkbox>
                          <input
                            type="checkbox"
                            id="{{ 'checkedEmployee' + employee.u_id }}"
                            name="{{ 'checkedEmployee' + employee.u_id }}"
                            [checked]="employee.is_checked"
                            (change)="onCheckEmployee($event, employee)"
                          />
                        </app-checkbox>
                      </td>
                      <td>{{ employee.fullname }}</td>
                      <td>
                        {{ employee.employee_type_name }}
                      </td>
                      <td>
                        {{ employee.minimal_group_name }}
                      </td>
                      <td>
                        <div class="grid grid--gap-4">
                          <div class="grid__box grid__box--size-min">
                            <app-combobox
                              [items]="migrateSectorsList"
                              (callback)="onChangeSectorForMigrateEmployee($event, employee)"
                              [textKey]="'sector_number_str'"
                              [initBy]="employee.sector"
                              [name]="'sectorSelected'"
                              [defaultText]="'Выберите участок'"
                              [isDisabled]="false"
                            ></app-combobox>
                          </div>
                          <div class="grid__box grid__box--size-min">
                            <span class="color-red-dark employee-migrate__required-start">*</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-24 mb-24">
          <div class="grid__box--size-4">
            <div class="grid">
              <div class="grid__box grid__box--size-5">
                <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">
              Сведения об<br />
              изменении записи
            </div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-11">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title--vertical title--s">Дата создания</span>
                  </div>
                  <div class="grid__box grid__box--size-4">
                    <div *ngIf="isEditMode">
                      {{ currentSelectedPlot.create_date | dateFormat: 'DD MMMM YYYY г. HH:mm' }}
                    </div>
                    <div *ngIf="!isEditMode">
                      <div class="mdash"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid mt-16 grid--va-middle">
              <div class="grid__box grid__box--size-11">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title--vertical title--s">Дата изменения</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div *ngIf="isEditMode">
                      <span *ngIf="currentSelectedPlot.update_date">
                        {{ currentSelectedPlot.update_date | dateFormat: 'DD MMMM YYYY г. HH:mm' }}
                      </span>
                      <div class="mdash" *ngIf="!currentSelectedPlot.update_date"></div>
                    </div>
                    <div class="mdash" *ngIf="!isEditMode"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid mt-16 grid--va-middle">
              <div class="grid__box grid__box--size-11">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title--vertical title--s">Создал</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div *ngIf="isEditMode">
                      <a
                        [routerLink]="[
                          '/users',
                          {
                            u_id: $safeNavigationMigration(currentSelectedPlot.created_by_user?.user_id)
                          }
                        ]"
                        class="link"
                      >
                        {{ currentSelectedPlot.created_by_user?.full_name }}
                      </a>
                    </div>
                    <div class="mdash" *ngIf="!isEditMode"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid mt-16 grid--va-middle">
              <div class="grid__box grid__box--size-11">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title--vertical title--s">Изменил</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div *ngIf="isEditMode">
                      <span *ngIf="currentSelectedPlot.updated_by_user">
                        <a
                          [routerLink]="[
                            '/users',
                            {
                              u_id: currentSelectedPlot.updated_by_user.user_id
                            }
                          ]"
                          class="link"
                        >
                          {{ currentSelectedPlot.updated_by_user.full_name }}
                        </a>
                      </span>
                      <div class="mdash" *ngIf="!currentSelectedPlot.updated_by_user"></div>
                    </div>
                    <div class="mdash" *ngIf="!isEditMode"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid mt-16 grid--va-middle">
              <div class="grid__box grid__box--size-11">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-2">
                    <span class="title title--vertical title--s">Версия</span>
                  </div>
                  <div class="grid__box grid__box--size-2">
                    <div *ngIf="isEditMode">
                      {{ currentSelectedPlot.version_number }}
                    </div>
                    <div *ngIf="!isEditMode">
                      <div class="mdash"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </step>
      <steps-errors [fieldsInvalid]="fieldsInvalid" [fieldsDescription]="fieldsDescription" [backendError]="backendError"></steps-errors>
    </steps>
  </form>
</div>
